import { fork } from 'typed-redux-saga';

import { DTMFStateMachine } from '../../../../../shared/features/room-agent/dtmf/dtmf-state-machine';
import { rootParticipantListSaga } from '../../../../../shared/features/room-agent/dtmf/participant-list/sagas';
import { SignalingAPI } from '../api/SignalingAPI';

export function* dtmfSaga({ signaling }: { signaling: SignalingAPI }) {
    const stateMachine = new DTMFStateMachine();
    yield* fork([stateMachine, stateMachine.start], signaling.dtmfEvent);

    yield* fork(rootParticipantListSaga);
}
